import React from 'react';

export const TrophySpot = (): React.ReactElement => (
  <svg fill="none" height="56" width="57" xmlns="http://www.w3.org/2000/svg">
    <circle cx="28.5" cy="28.057" fill="#F7F5F0" r="27.678" />
    <path
      clipRule="evenodd"
      d="M17.313 22.112c0 1.84 1.332 3.426 3.182 3.787l1.898.37-.475 2.316-1.898-.37c-2.981-.582-5.127-3.136-5.127-6.103V17.98c0-.979.813-1.772 1.815-1.772h4.842v2.362h-4.237v3.543z"
      fill="url(#a)"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M17.313 22.112c0 1.84 1.332 3.426 3.182 3.787l1.898.37-.475 2.316-1.898-.37c-2.981-.582-5.127-3.136-5.127-6.103V17.98c0-.979.813-1.772 1.815-1.772h4.842v2.362h-4.237v3.543zM40.33 22.112V18.57h-4.237v-2.362h4.841c1.003 0 1.816.793 1.816 1.772v4.133c0 2.967-2.146 5.52-5.127 6.103l-1.898.37-.475-2.316 1.898-.37c1.85-.361 3.181-1.946 3.181-3.787z"
      fill="#56BB9A"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M19.178 25.36c.4.255.854.441 1.345.538l1.869.37-.468 2.317-1.869-.37a6.346 6.346 0 0 1-.877-.24V25.36zm0-9.153h2.384v2.362h-2.384v-2.362z"
      fill="url(#b)"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M38.464 18.57H36.08v-2.363h2.384v2.362zm0 9.405c-.283.1-.575.18-.877.24l-1.87.37-.467-2.316 1.87-.37a3.91 3.91 0 0 0 1.344-.54v2.616z"
      fill="url(#c)"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M27.75 31.77h2.5v7.073h-2.5v-7.074z"
      fill="#56BB9A"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M21.207 14.086h15.587c.33 0 .6.265.6.593v11.265c0 4.584-3.758 8.3-8.394 8.3-4.635 0-8.393-3.716-8.393-8.3V14.679c0-.328.269-.593.6-.593zM27.036 36.367h3.571c.986 0 1.786.792 1.786 1.769v1.178c0 .326-.267.59-.595.59h-5.953a.592.592 0 0 1-.595-.59v-1.178c0-.977.8-1.769 1.786-1.769z"
      fill="#56BB9A"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M24.195 38.844h9.61c.995 0 1.802.791 1.802 1.768v1.179c0 .325-.27.59-.6.59H22.992a.595.595 0 0 1-.6-.59v-1.179c0-.977.806-1.768 1.802-1.768z"
      fill="#184634"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="m29 24.67-2.097 1.086.4-2.303-1.696-1.63 2.345-.337L29 19.391l1.049 2.095 2.344.336-1.696 1.631.4 2.303L29 24.67z"
      fill="#F9F9F9"
      fillRule="evenodd"
    />
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="a"
        x1="11.45"
        x2="11.45"
        y1="13.12"
        y2="36.86"
      >
        <stop stopColor="#FFCB00" />
        <stop offset="1" stopColor="#FF7E00" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="b"
        x1="18.1"
        x2="18.1"
        y1="9.548"
        y2="30.224"
      >
        <stop stopColor="#56BB9A" />
        <stop offset="1" stopColor="#38AF88" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="c"
        x1="34.894"
        x2="34.894"
        y1="8.582"
        y2="29.875"
      >
        <stop stopColor="#56BB9A" />
        <stop offset="1" stopColor="#38AF88" />
      </linearGradient>
    </defs>
  </svg>
);
